<template>
    <div class="page white_bg">

        <div style="height: 46px;"><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white_bg" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body padding16">

            <div class="">

                <!-- 开启消息通知 （Web端没有消息通知功能） -->

                <div class="menu">
                    <div class="menuItem flexLayout" v-for="dataItem in dataList" :key="dataItem.id"
                        @click="viewItem(dataItem)">
                        <div class="iconArea" style=" margin-right: 13px;">
                            <i class="icon systemIcon size32" v-if="dataItem.messageType == 1"></i>
                            <i class="icon couponIcon size32" v-if="dataItem.messageType == 2"></i>
                            <i class="icon footmarkIcon size32" v-if="dataItem.messageType == 3"></i>
                        </div>
                        <div class="contentArea flexItem">
                            <div class="lineHeight21r16f">
                                <div class="color333 font18r">
                                    <strong class="bold">{{messageTypeEnum.getTitleByCode(dataItem.messageType)}}</strong>
                                    <span class="remindRedPoint marginL4" v-if="dataItem.messageCount">
                                        {{dataItem.messageCount}}
                                    </span>
                                    <span class="floatR grey font12r" v-if="dataItem.firstMessageTime">
                                        {{formatDate(dataItem.firstMessageTime)}}
                                    </span>
                                </div>
                            </div>
                            <div class="font14r darkgrey marginT8 breakWord">
                                {{dataItem.firstMessageTitle}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何消息
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多消息了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>

        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';
import messageTypeEnum from './messageTypeEnum';

// util
import appHelper from '@/util/appHelper';

const config = {
    name : 'meMessageIndex',
    title : '消息中心',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/message/center',
            dataPath : 'data'
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            messageTypeEnum
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.redirect('/me/message/list/' + dataItem.messageType, {
                id : dataItem.id
            });
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = [{
                id : 'system',
                messageType : 1,
                messageCount : 1,
                firstMessageTitle : '师讯赢来好消息！将于2021年1月3的hweoghweg',
                firstMessageTime : new Date().getTime()
            },{
                id : 'coupon',
                messageType : 2,
                messageCount : 203,
                firstMessageTitle : '您有一张满100减20的优惠券未使用',
                firstMessageTime : new Date().getTime()
            },{
                id : 'footmark',
                messageType : 3,
                messageCount : 45,
                firstMessageTitle : '师讯赢来好消息！将于2021年1月3的hweoghweg',
                firstMessageTime : new Date().getTime()
            },];
        }
    }
}
</script>

<style lang="scss" scoped>

.grey {
    color: #B8C2D6;
}
.darkgrey {
    color: #5B616C;
}
.menu {
    .menuItem {
        padding: 24px 0 12px;
        .iconArea {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background: #FFF2D8;
            text-align: center;
            .icon {
                margin-top: 10px;
            }
        }
        .contentArea {
            border-bottom: solid 1px #F6F6F6;
        }
        .remindRedPoint {
            width: auto;
            min-width: 14px;
            height: 14px;
            line-height: 14px;
            box-sizing: border-box;
            padding: 0 2px;
            border-radius: 7px;
            font-size: 10px;

            vertical-align: middle;
            position: relative;
            top: -2px;
        }
    }
}
.systemIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFS0lEQVRoQ+1Za2wUVRS+d7azq6FRQ2OoQSpoDAgm1JSdVX75IArEB+0uSzSEGBIjqPEVUcGYQFJfSNTEiK8YMIY/y+62jYnIDx6JIWZ32+KLH2CUGNqCEEwgtKQ7M/f47ZQlbLvdObOzhTTp/mk6c853v++ee885c68Uk/wnJzl/MSXgWkfQVwQoIQKmFl5LUs7UFP2kr8zt4wiy0sajSomXYZvUo9mvpBSK41fOpmoB5u7wYiXl11LK+Q4wiYsioBYHW3O/VCKTT4XDguQhIaV+ye83EbCfCbZ2Z6sR4VkAdUVmmBZtFUKuGT0gCToZtM2FMn74TDky1BmeZVqyB+RvLn1PhP+/0aV4U7Zlz3oRwhbgLJeA8Rxmuh0Ebhh/EPpVCvkKxNwOVrNgd0xTaoA0bS5obkbEGsf1JfEf0spGvS2DyGIkxo8tIJ+K7ADe0wxM3yYQuicUyyznALEEAFCaKcPCzGscUN82RIPBWLaeg8MSUAAaTkZ+QFiXcUD92mD5JUPR7EoODluAlVr0uBKBLg6oXxup1BJuSmYLwDLSzLRxGtmnwS/BSv4Ypx/r/1buGHwBB+6vM88ODYxNgdyheHYFAcFopolb3NgCsIlfx17+gEfDpxWJF4KxzGccFJYA6rh3tmmro5j9IAfUtw2JC7rS5sn4z/1uWCwB+WTkOxSY1W5gtX1PXwaj2XVumK4C8mljIVqtXk81gOg8BO9CKT2NqnwLSDQLonsu9z9urArvSdi6ojtlPHu8knlZAZRouVGEZKNtB+bZij5G+Z/DGRMkFUrdpjrd/lQ+1jN0pQ8lFtRbWv2rJGkzMpnrxDm+RPuA926dEH3iOnlKLs+cH82jBGg4GV4gpLYbD+9iES4xKjRktDYYze2s5JtPhteDPzYoU0TJLFC3ruwlMt5zrvh4lIDIh4B9zTt50BHqbT2aa+f4DqeMd7C0NnFsx8w4qY16LPd+WQH5lLEdVNZ7BkbvoqvBRhk/coHjS4n7ppuafbKarIY2YyvajDdqKoCIOkOxbCuHfNEGUfgRUXjEi8/I3p4IAUK8F4pmPC0JpOZPsO5emhJw5QxUuweQf7rQgK3wMpvDSWMv0vPDXnwmbAlhZQ7p9uCMa76JMSvtmJW3vM5Kwf5qpVFs4i3IQiiGI7+SOkBpo8EkcRCP7/YuglnIUsazwP68ukImfsdZTFTGMn+WFVB8iFaiyQ7IZlsEcIZDaxCVJpagGrcSSM/HNSF3So16AxpOO1bkTowpbG7E8h3hZmE7Zzn8D3qiPGLbC+zDIw2daEQCXw2MaW7jXX5faOY0mo9zomOVfFhNFbLTLoT8KfbgNTGsUTvtpK6EMcfU5BHM6vU14eYG4nzQKLTSuVNupqwIFECu6ielUM+jq0Vf5v5jCyDno/7iv4jCdHfY6i2QJvuCbdnbav5R7xyrpCJnJl6AGEBfNZM7BewIWOnIE4pEJxfYjx1IPahHMwc4GGwBaH/3oP1dygH1bUOUwNnoKg4OS4BzuJs27KqqJ4fFaBuicxBwE8eVJaAAhOP1DP4YHFD/NrQfRyoPcXDYAi7dzHwE0CcrRQJZ5ARAt+CA9i9catxRuORARvkbz/pwL7YdbcnccYmhFUG1/laXtIF7U8MWUBx0pLXQvkA2ioyJPMjjiqnF+xWTg3SIpL0u1Nb9B2fmizaeBRQdrWQkakuxDQCznWdVXvKhYTsaELShLpb73gtx3wIczt0tuvWP9iJKxFJJtE2PZfdySFgdi5bZSovAp19vmLZDPnDQ4viVs6k6AtUOWGu/KQG1nlGveJM+Av8D51EwT9j2C4gAAAAASUVORK5CYII=');
}
.couponIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEuUlEQVRoQ+2ZXWwUVRTH79ndO9uGUCMYecD4QQwKBBJQZlOjJIqJD2IqO2slkuCLqQ8ECSQkQkTw68EE41efJCY8IDG1u2ggJEZEpCk4uyAxDUR4QNE0SqwaLWnpzs49ntntym6783Fn7kBI2Jd2e+898//dc849506B3eAfuMH1s5sA19uD18QDWNBnVwSsZ4jf8GeKAyqhYwfAg4tvta60f80AltaEi/c0o7RJFUSsAJPiB0j8okbBiGxXOmduUQERGwAeeOA2ayJ5dKr4umhgYjs3Sm9GhYgFAL/IzClb+C0A3OcpEHGDliv2RoFQDlAVX8HjwGBeIGEgNmrZ0geB5raYpBQA+zrnlpP2scDia4IqfNalmfDoz1fCQCgDwPzSu8rIj1HY3CknBI9oRnGl3Jqrs5UBWP36ZgR4R1ZI1GRWBuAIL/dnvqPmJCMHgR+SB16SW6PIA07MW0l7H0+JHtYxctH68/aTbsemu0Ac4bZ9L3Sf+icMRGgPVBM2YR+fGvOIeNYRQn9fKCHoMLcvr4buM5edNdin32OlWIeWLf7gZyMUgLt4NqwZppPEaBX0PYSxzk/A1XEco/nfM2Scli+jHeCAbAfPma972ZAGcBNfewiO8RTMgy7zErULIA8xXSoA28Kz5i43CCkAb/GTCIjntLT9MDx1aoTmt1tJQTsb8eNRsQMDBBFfl0m7/2MiITYxhCXkiLcjyp/cGdGj5Uq7p9oKBBC+SDlRxUwKg60E9TQdsaGPSzKEVGeeS2fNTxshfAFq4rVBEjE3zE4C4Ms8W6x6YSKv76Q2Y0cYO7UUY+Ocp+ZA1+Bo3YYnQFTxtWfibxqzOsE4fdH5Xu6n0wng+bAQ3E7cAd0nhn0BVIhvyIlhDcQKMEoXrLy+jfLirXAA06t2Sw+oFP+/UMR/KQdOk0s6yQOaNACy3dwwX6RQRs8ciEX8FLWUFytTbX8NWuOzPqbitdYXhsRrObOn1bwmD2DfIq2cnDFEiTbf12iECTxl3w9dJ8/Vil1mH5la424Oe6nZ2+A23gRACfYgubcUQVuwpYhneNv4I7Bq6G+CSJTz+k+t7hFBLv/NHqhexFO/UKy2B1MSYZYDIZJPkIVx6mjPUyjNbrRGgf5G2jBf9XvCtCSeyC9/FjDxCUEk/RYrHScgKlQJErTAr//xTGJnsJLXVwsGffRrSqlIF2NUK36l1vluGsbK/szj1Lx9FfS5roWMIJ4kiM+vEcQot8V86C79HlR4fZ5nJa5CINvv9OayhqXnA24mL7wru863F7I+W/6QANhKEEPJhD2AFSgLYCsoXLep8k6Q0ybQMSpDXynoqwTCAZk1reZS/L+WNoo7w9rx9YCXYaobh8kz4d/p+Ny2gkBFArDyme10XnveWV1dr0C8YzsSAL0H6iUL64PsVNPZrUh8JAD8cskMa7RtmELoFhkAmSIVxG5oD+ChTIc1hn/ItMaqxUfygLOYmrAX6MdHzmssv92KQ3xkgCpEQV9HV4w9nhAK/pGhvA40GpwoZNYAIvX1LTwRo3glHqiDVCEE29vUxcYsXimAY4xeJT5GbcH7dNGayVC8ks6V9vrlRtRx3+SL+oC4198EiHuH/ez/BzqQ1kB0wtO7AAAAAElFTkSuQmCC');
}
.footmarkIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAElElEQVRoQ+1ZXYhbVRCeucm9ISIoW/VBhfXnRRRFSXdvKopdK6JtoTY3LlItiIJKH1QQfLSivhQE8e/FPkgREbO5rUt3H4Rqogjd5NqqLfUPWxcqlBZaS/8wuckdv2zdZbtrknPuT3Wh9yUPmflmvpk5c86Zw7TEP17i/tMlAv91BmPJQNO1PyShjcJyJCWyKV30dl4sYpEJNHfYOQro2zmHhU5YxdqyJUOg5Q6vCYgn5jssRG8QSdtgPsNC0ymiKXZqfyRBKoYMLB+mwJgi4u5YQm2QmmBDNluF+g9xEglNQEorBnyj/R762GM9nb/AWwEP3moOHH2BR6b/ioNIKAKdupc2jSPm14VyQuQ70+SHeV3taCj9eUraBHzXHkEcJxH5bCTjIgfMVPMeXv/9ySg4WgTEta/3SX5DGWSiGJ3VFZKxjFMfjYKlRaBRtidRNqujGFykK5y3ilO1sJjKBLBZ5WFkd1hDXfVEtlnF+pNhcZUJIPouol8Ia6gHgbPmssuu5JFqKwy2MoFm2T6NhXt5GCP9dBCYe81C7Zt+cv/2vxIB2X7HNb5kI7e8bg6KBK9lit7m5Ai4Qzf5ZBwMY0BFR0R+zBTrt6nILpRRy0BpRdZPBefCGFDXaeUsZ89edfnzkkoEOoLN8vAxHHeu1jWgLC/0Nk6xLyrL/yOoQ2AXCKzSNaAhf9rMnBvktfv/1NDRyIBrvwngl3TAdWURzVdMp/a6jp5yBhrloSeYjY90wLVlRU6ZQepGHt19QlVXmUCznLeJBef+pD9513Lqz6taUSaQ9F4w5zA2BQQqbzmep0JCmcBMJ3KHcQmJ5yTayzmcUg9a7bN38uiBM/1I6BFIupVe4K14ZpYf4NW1U71IaBFouPbvULihX1Ri+19on2nI/VyoH++G+f8mAK9xzPjFMltred1eXKQWf1oEEt+Nu6ZOTmJdPJdxvE8XiigTkBKl/JTdmSSkYysRXSCRL0xub2Rnz5FZVXUC5dwtPqd/0rUZt7whVEwXa642AezEo9iJF6Uwbgf74ZnUujZUBnAnfh/gm/oZSPD/Fja4lzHZe2u+DaUSwhyIm9vtQxe1hc54KcdF+CsmqZhpGedHvMOhFrE/Zj8oBn2eYHTPQ2OyjW7zNWaoFQmMquXU9uO+jHFk908pAw13eIKJ1yRCQKiKQ/04yqNirq/v6+ewdgYan+Vu53YKE+Ue0+cIzLBRbcB9+JOwEH0zgHFKBRFaqWsApfArwAdA/KqeuhI8YxW9rbr4Sm0UpbMBpfOxKnjnFAmnK6jap1C4PxtM27D+t/SsYZa7zUI99MSvZwaa5eV3EaU8ZACPLIs/OHwILzBV/FYsNqqzrzAgXgLxRwnRReU9jizc10X/MNrioG7da7VRf2xoVcD8DjPfiqhOz0SYpWoKf9nt2Uh25G72g7SHk9gVwrzFYNnVeXIi4ZXIyKtzDkQsnw5O3zWgWj4L5TqLn9rpnTAw2AXjA7TJZ8PiK62BqOB4hsriGeppYXoIRPKI/jG0dc8gKqWd+mRU/EQzEIdzKhiJlZCK8ThkLhGII4pRMP4G2pmTQNmqN/wAAAAASUVORK5CYII=');
}
</style>
